import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useMediaQuery,
  useTheme,
  Badge
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Science as ScienceIcon,
  Add as AddIcon,
  People as PeopleIcon,
  Assignment as AssignmentIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';

const MobileNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const user = useSelector(state => state.auth.user);
  const { list: samples } = useSelector(state => state.samples);
  
  const [value, setValue] = useState(0);

  const getNavigationItems = () => {
    const baseItems = [
      { label: 'Dashboard', icon: <DashboardIcon />, path: '/' }
    ];

    if (['Admin', 'Sample Collector'].includes(user?.role)) {
      const items = [
        ...baseItems,
        { label: 'Samples', icon: <Badge badgeContent={samples?.length || 0} color="primary"><ScienceIcon /></Badge>, path: '/samples' },
        { label: 'Create', icon: <AddIcon />, path: '/samples/create' }
      ];
      
      if (user?.role === 'Admin') {
        items.push({ label: 'Users', icon: <PeopleIcon />, path: '/users' });
        items.push({ label: 'Utility', icon: <SettingsIcon />, path: '/dropdowns' });
      }
      
      return items;
    }

    if (user?.role?.includes('HOD') || user?.role?.includes('Analyst') || user?.role === 'Tester') {
      return [
        ...baseItems,
        { label: 'My Tasks', icon: <AssignmentIcon />, path: '/samples' }
      ];
    }

    return baseItems;
  };

  const navigationItems = getNavigationItems();

  useEffect(() => {
    const currentIndex = navigationItems.findIndex(item => 
      item.path === location.pathname || 
      (item.path !== '/' && location.pathname.startsWith(item.path))
    );
    if (currentIndex !== -1) {
      setValue(currentIndex);
    }
  }, [location.pathname, navigationItems]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(navigationItems[newValue].path);
  };

  if (!isMobile || navigationItems.length <= 1) {
    return null;
  }

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 1000,
        borderRadius: 0
      }} 
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={handleChange}
        showLabels
        sx={{
          height: 64,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 12px 8px',
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            '&.Mui-selected': {
              fontSize: '0.75rem',
            },
          },
        }}
      >
        {navigationItems.map((item, index) => (
          <BottomNavigationAction
            key={index}
            label={item.label}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileNavigation;